module.exports = __webpack_public_path__ + "static/media/bg.8685d8f8.png";